module.exports = __webpack_public_path__ + "img/dot-arrow.1273757b.svg";